import { LucideIcon } from "lucide-react";

import clsx from "clsx";

// TODO: Decide if we want to include line-by-line errors in alert
//
// import { useState } from "react";
//
// import { ChevronDown, ChevronRight } from "lucide-react";
//
// function ErrorsAccordian({ errors }: { errors: string[] }) {
//   const [open, setOpen] = useState(false);
//
//   return (
//     <div>
//       <button
//         className="flex items-center w-full text-sm px-3 py-2 cursor-pointer"
//         onClick={() => setOpen((open) => !open)}
//       >
//         {open ? <ChevronDown size={20} aria-hidden /> : <ChevronRight size={20} aria-hidden />}
//         <span>{errors.length} errors</span>
//       </button>
//       {open && (
//         <ul
//           className={clsx(
//             "flex flex-col text-xs max-h-64 overflow-scroll",
//             "bg-red-200/30 border-t border-red-200/90",
//             "dark:bg-black/40 dark:border-red-900",
//           )}
//         >
//           {errors.map((error, index) => {
//             return (
//               <li
//                 key={index}
//                 className="px-4 py-2 not-last:border-b border-red-200/70 dark:border-red-800/30"
//               >
//                 {error}
//               </li>
//             );
//           })}
//         </ul>
//       )}
//     </div>
//   );
// }

type AlertVariant = "info" | "success" | "error" | "warning";

interface AlertProps {
  variant: AlertVariant;
  status: string;
  text?: React.ReactNode | string;
  Icon: LucideIcon;
  children?: React.ReactNode;
  message?: string;
  errors?: string[] | null;
}

function AlertMessage({ message, errors }: { message: string | null; errors: string[] | null }) {
  const error = errors && errors.length > 0 ? errors[0] : null;

  if (message === null) {
    return null;
  }

  return (
    <p
      className="mt-1 text-xs text-black/40 dark:text-white/40"
      style={{ wordBreak: "break-word" }}
    >
      {`${message}${error ? `: ${error}` : ""}`}
    </p>
  );
}

export function Alert(props: AlertProps) {
  const { variant, status, Icon, children, text = null, message = null, errors = null } = props;

  return (
    <div>
      <div
        className={clsx("p-4 rounded-xl border", {
          // Info
          "bg-blue-100/75 dark:bg-blue-950/50 text-blue-950 dark:text-blue-100": variant === "info",
          "border-blue-200 dark:border-blue-900": variant === "info",
          // success
          "bg-green-100/75 dark:bg-green-950/50 text-green-950 dark:text-green-100":
            variant === "success",
          "border-green-200 dark:border-green-900": variant === "success",
          // Error
          "bg-red-100/75 dark:bg-red-950/50 text-red-950 dark:text-red-100": variant === "error",
          "border-red-200 dark:border-red-900": variant === "error",
          // Warning
          "bg-orange-100/75 dark:bg-orange-950/50 text-red-950 dark:text-orange-100":
            variant === "warning",
          "border-orange-200 dark:border-orange-900": variant === "warning",
          // Common
          "mb-6": !!children,
        })}
      >
        <div
          className={clsx("flex gap-x-1 items-center", {
            "mb-2 pb-2 border-b": !!text,
            "border-blue-200 dark:border-blue-900": variant === "info",
            "border-green-200 dark:border-green-900": variant === "success",
            "border-red-200 dark:border-red-900": variant === "error",
            "border-orange-200 dark:border-orange-900": variant === "warning",
          })}
        >
          <Icon
            className={clsx("flex-none", {
              "stroke-blue-600": variant === "info",
              "stroke-green-600": variant === "success",
              "stroke-red-600": variant === "error",
              "stroke-orange-600": variant === "warning",
            })}
            size={20}
          />
          <span className="font-bold text-base">{status}</span>
        </div>
        {text && <p className="text-sm">{text}</p>}
        <AlertMessage message={message} errors={errors} />
      </div>
      {children}
    </div>
  );
}
